import Typography from 'components/atoms/typography/typography';
import IndeterminateCheckbox from 'components/molecules/indeterminate-checkbox/indeterminate-checkbox';
import DocumentsTableStateContext from 'components/organisms/documents-table/documents-table-state-context';
import { useContext, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './documents-table.scss';
import { DocumentOrderBy, OrderDirection } from 'Enums';

export const DocumentsTableHeader = () => {
  const { state, dispatch } = useContext(DocumentsTableStateContext);

  const [currentSortKey, setCurrentSortKey] = useState<keyof typeof DocumentOrderBy>(DocumentOrderBy.Type);
  const [currentSortOrder, setCurrentSortOrder] = useState<keyof typeof OrderDirection>(OrderDirection.asc);

  const isAllSelected = useMemo(
    () => state.rowSelection.length === state.slicedDocuments.length && state.slicedDocuments.length > 0,
    [state.rowSelection.length, state.slicedDocuments.length],
  );

  const handleRowSelection = () => {
    if (state.rowSelection.length === state.slicedDocuments.length) {
      dispatch({
        type: 'RESET_ROW_SELECTION',
      });
    } else {
      dispatch({
        type: 'SELECT_ALL_ROW_SELECTION',
      });
    }
  };

  const handleSort = (key: keyof typeof DocumentOrderBy) => {
    const newSortOrder =
      currentSortKey === key && currentSortOrder === OrderDirection.asc ? OrderDirection.desc : OrderDirection.asc;

    setCurrentSortKey(key);
    setCurrentSortOrder(newSortOrder);

    dispatch({
      type: 'SET_SORTING',
      payload: { key: key, order: newSortOrder },
    });
  };

  const renderSortableColumn = (id: keyof typeof DocumentOrderBy, label: string) => (
    <th className="documents-table__cell table__th table__can-sort" onClick={() => handleSort(id)}>
      <div className="table__header-content">
        <Typography>
          <FormattedMessage defaultMessage={label} id={`Documents.${label}`} />
        </Typography>
        {currentSortKey === id && (
          <span className={`table__sort-icon ${currentSortOrder}`}>
            {currentSortOrder === OrderDirection.asc ? '↑' : '↓'}
          </span>
        )}
      </div>
    </th>
  );

  return (
    <thead>
      <tr>
        <th className="documents-table__checkbox table__th" colSpan={1}>
          <IndeterminateCheckbox
            {...{
              checked: isAllSelected,
              indeterminate: false,
              onChange: handleRowSelection,
            }}
          />
        </th>
        {renderSortableColumn('Type', 'Type')}
        {renderSortableColumn('Description', 'Description')}
        {renderSortableColumn('Status', 'Status')}
        {renderSortableColumn('VisibleDate', 'Visible')}
        <th className="documents-table__cell table__th">
          <div>
            <Typography>
              <FormattedMessage defaultMessage={'Handling'} id={'Documents.Handling'} />
            </Typography>
          </div>
        </th>
      </tr>
      <tr>
        <th colSpan={6}>
          <hr className="table__hr" />
        </th>
      </tr>
    </thead>
  );
};
